import React from "react";
import { ToastContainer } from "react-toastify";
import { StyledBreadcrumb, Tabs } from "@aureskonnect/react-ui";
import { useLocation } from "react-router-dom";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import { store } from "../../../components/VerticalLayout/store";
import { setModify } from "./store";

import PageTitle from "@components/Common/PageTitle";
import MessageInfo from "@components/Common/MessageInfo";
import { getPathAuthorization } from "@components/VerticalLayout";
import { MainColorTabsWrapper } from "@components/Common/MainColorTabsWrapper";

import VatRates from "./VatRates";
import VatRatesShop from "./VatRatesShop";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";

function VatRateComponent() {
    const location = useLocation();
    setModify(getPathAuthorization(location.pathname).Modifie);
    const { t } = useTranslation();

    const { oneShop } = useSnapshot(store);

    const [typeDisplay, setTypeDisplay] = React.useState<string>("notArchived");
    const [typeDisplayShop, setTypeDisplayShop] = React.useState<string>(
        "notArchived"
    );

    const [tab, setTab] = React.useState<number>(0);

    const [limit, setLimit] = React.useState<number>(1);

    const tabs1 = (
        <VatRatesShop
            franchise={false}
            typeDisplay={typeDisplay}
            setTypeDisplay={setTypeDisplay}
        />
    );

    const tabs2 = (
        <Tabs
            tabs={[
                {
                    content: (
                        <VatRatesShop
                            franchise={true}
                            typeDisplay={typeDisplay}
                            setTypeDisplay={setTypeDisplay}
                        />
                    ),
                    disabled: false,
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark  cmn_btn_franchise"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                            onClick={() => {
                                setTab(0);
                            }}
                        >
                            {t("VAT rate")}
                        </div>
                    ),
                },
                {
                    content: (
                        <VatRates
                            typeDisplayShop={typeDisplayShop}
                            setTypeDisplayShop={setTypeDisplayShop}
                            setLimit={setLimit}
                        />
                    ),
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark border-0  cmn_btn_boutique"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                            onClick={() => {
                                setTab(1);
                            }}
                        >
                            {t("Shops vat")}
                        </div>
                    ),
                },
            ]}
        />
    );
    return (
        <React.Fragment>
            <ToastContainer limit={limit} />
            <PageTitle title={t("General settings")} />
            <div className="tva_txt_vatRate">
                <div className="page-content__clz ">
                    <StyledBreadcrumb
                        items={[
                            {
                                item: "Settings".toUpperCase(),
                                link: `${process.env.REACT_APP_PORTAIL_URL}`,
                            },
                            {
                                item:
                                    localStorage
                                        .getItem("selectedAccount")
                                        ?.toUpperCase() || "",
                                link: oneShop
                                    ? "/setting/customer-account"
                                    : "/compte",
                            },
                            {
                                item: t("General settings").toUpperCase(),
                                link: "#",
                            },
                            {
                                item:
                                    tab === 0
                                        ? typeDisplay === "archived"
                                            ? t(
                                                  "Archived VAT rate"
                                              ).toUpperCase()
                                            : t("VAT rate").toUpperCase()
                                        : tab === 1
                                        ? typeDisplayShop === "archived"
                                            ? t(
                                                  "Archived VAT rate"
                                              ).toUpperCase()
                                            : t("VAT rate").toUpperCase()
                                        : "",
                                link: "#",
                            },
                        ]}
                    />
                    <MessageInfo
                        message={t(
                            "The VAT (Value Added Tax) related to an account can be configured in this section. It is important to note that a shop can only use VAT rates specific to its country."
                        )}
                    />

                    <MainColorTabsWrapper>
                        {oneShop ? tabs1 : tabs2}
                    </MainColorTabsWrapper>
                </div>
            </div>
        </React.Fragment>
    );
}
export default React.memo(VatRateComponent);
